<ng-container *ngIf="isDataExist; then showAddresses else emptyAddressesTable"></ng-container>


<!---------------------------->
<!-- Address Details:-->
<!---------------------------->
<ng-template #showAddresses>
  <div class="mat-elevation-z8 table-container">
    <table [dataSource]="addresses" mat-table>
      <ng-container [matColumnDef]="tableColumns.AddressType">
        <th *matHeaderCellDef mat-header-cell>Type</th>
        <td *matCellDef="let address" mat-cell>{{address.addressTypeCode}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AddressLine1">
        <th *matHeaderCellDef mat-header-cell>Line 1</th>
        <td *matCellDef="let address" mat-cell>{{getDisplayAddress1(address)}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AddressLine2">
        <th *matHeaderCellDef mat-header-cell>Line 2</th>
        <td *matCellDef="let address" mat-cell>{{getDisplayAddress2(address)}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Suburb">
        <th *matHeaderCellDef mat-header-cell>Suburb</th>
        <td *matCellDef="let address" mat-cell>{{address.suburb}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Country">
        <th *matHeaderCellDef mat-header-cell>Country</th>
        <td *matCellDef="let address" mat-cell>{{address.countryCode}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CityTownCode">
        <th *matHeaderCellDef mat-header-cell>City-Town Code</th>
        <td *matCellDef="let address" mat-cell>{{address.cityTownCode}}</td>
      </ng-container>


      <ng-container [matColumnDef]="tableColumns.PostalCode">
        <th *matHeaderCellDef mat-header-cell>Postal Code</th>
        <td *matCellDef="let address" mat-cell>{{address.postalCode}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.POBoxNumber">
        <th *matHeaderCellDef mat-header-cell>PO Box</th>
        <td *matCellDef="let address" mat-cell>{{address.poBoxNumber}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Actions">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let address" mat-cell>
          <span [matTooltip]="editTooltip()">
            <button mat-icon-button
                    [disabled]="isProcessing || !hasOnboardingQCRole || isApplicationLocked"
                    [class.disabled]="!hasOnboardingQCRole || isApplicationLocked"
                    (click)="onEditAddress(address)">
              <mat-icon class="table-icon">edit</mat-icon>
            </button>
          </span>
          <app-busy-spinner-icon *ngIf="isProcessing"></app-busy-spinner-icon>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
  </div>
</ng-template>

<ng-template #emptyAddressesTable>
  <div class="text-center">
    <label class="column-label">No addresses specified</label>
  </div>
</ng-template>
